import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { activityLog, activityLogAsc, activityLogDesc } from '../mockData/activity-log-data';

const ActivityLogApi = [
  rest.get(`${API_ROOT}activity-manager`, (req, res, ctx) => {
    const triggerCodes = req.url.searchParams.get('triggerCodes');
    const order = req.url.searchParams.get('order');
    const orderBy = req.url.searchParams.get('orderBy');
    const selected = req.url.searchParams.get('selected');
    if (triggerCodes === 'true' || selected === {}) {
      return res(ctx.json(activityLog));
    }
    if (order === 'asc' || selected === '{"triggerCode":["Invite sent"]}') {
      return res(ctx.json(activityLogAsc));
    }
    if (order === 'desc' || orderBy === 'date') {
      return res(ctx.json(activityLogDesc));
    }
    if (orderBy === 'date' || order === 'asc') {
      return res(ctx.json(activityLogAsc));
    }
    return res(ctx.json({}));
  }),
];
export default ActivityLogApi;
